import { useQuery } from '@tanstack/react-query';
import { DCKDiagnosisApi } from 'api/DCK/DCKDiagnosisApi';
import { IDPatient } from 'models/DCK/basicInterface';
import { useLoadingStore } from 'store/useLoadingStore';
import { useLoginStore } from 'store/useLoginDataStore';

export const useDiagnosisFindByIdQuery = (id: string, patientData?: IDPatient | undefined) => {
    const { loginData } = useLoginStore();
    const { loading, setLoading } = useLoadingStore();

    return useQuery({
        // 쿼리 키 배열로 정의
        queryKey: ['diagnosisFindById', id, patientData],

        // 쿼리 함수
        queryFn: async () => {
            try {
                setLoading(true);
                // 실제 API 호출 함수로 변경 필요
                const response = await DCKDiagnosisApi.getDiagnosis(id, loginData.token);
                if (response.status === 'ok') return response.data;
            } catch (error) {
                // 에러 처리 개선
                const errorMessage = error instanceof Error ? error.message : '알 수 없는 오류가 발생했습니다';
                throw new Error(errorMessage);
            } finally {
                setLoading(false);
            }
        },
        retry: 1, // 무한 재시도 방지 (true는 무한 재시도를 의미)
        refetchOnWindowFocus: false, // 창 포커스 시 재요청 방지
        // staleTime: 5 * 60 * 1000,    // 5분간 데이터를 '신선한' 상태로 유지 (불필요한 재요청 방지)
        // gcTime: 10 * 60 * 1000,      // 10분간 비활성 쿼리 데이터 유지
    });
};
